module.exports = {
	baseURL: "/",
	baseRoute: "/*",
	version: "%GitHash%",
	host: "https://chemtest.berkeley.edu/chemnet",
	reactHost: "https://chemtest.berkeley.edu",
}
